<script setup lang="ts">
withDefaults(defineProps<{ size?: number | string; color?: string }>(), {
  size: 24,
  color: "currentColor",
});
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    :width="size"
    :height="size"
    :fill="color"
    v-bind="$attrs"
  >
    <path
      d="M15.8552 7.15206C15.6661 7.09254 15.6806 6.70989 15.8576 6.62034C16.4239 6.33388 16.8786 5.82445 17.0821 5.16589C17.4794 3.87995 16.7688 2.51235 15.4947 2.11127C14.2207 1.7102 12.8657 2.42752 12.4683 3.71346C12.2648 4.37202 12.3519 5.052 12.6565 5.61261C12.7517 5.78788 12.5481 6.11098 12.3591 6.05147L8.72544 4.90759C7.96651 4.66867 7.15939 5.09597 6.92269 5.86198L3.56567 16.7258C3.32897 17.4918 3.75231 18.3064 4.51124 18.5454L15.2746 21.9337C16.0335 22.1726 16.8406 21.7453 17.0773 20.9793L18.0388 17.8677C18.1175 17.613 17.9036 17.3577 17.6405 17.3321C17.4773 17.3162 17.3132 17.2832 17.1505 17.232C15.8764 16.8309 15.1657 15.4633 15.5631 14.1773C15.9605 12.8914 17.3154 12.1741 18.5894 12.5752C18.7522 12.6264 18.9057 12.6934 19.049 12.774C19.2799 12.9039 19.5997 12.8166 19.6784 12.5619L20.4343 10.1155C20.671 9.34951 20.2477 8.53485 19.4888 8.29594L15.8552 7.15206Z"
    />
  </svg>
</template>
